import { render, staticRenderFns } from "./TabOne.vue?vue&type=template&id=481b7d8b&"
import script from "./TabOne.vue?vue&type=script&lang=js&"
export * from "./TabOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports